export default __webpack_public_path__ + "static/media/onboarding4.c78d8486.png";